import { VerityOptions } from "@verity/api-client/types";

export type CourseInfo = {
	name?: string;
	code?: string;
};

export type RecordingMode = "off" | "normal" | "strict";

export type DisableClipboardMode = "off" | "tab" | "system";

export type DisableProctorMode = "off" | "extension" | "lockdown" | "mobile";

export type VerityProctoringOptions = Omit<
	VerityOptions,
	"enabled" | "password" | "thirdPartyAssessmentOptions" | "isLiveProctored"
>;

export type VerityOptionsToSubmit = Omit<VerityOptions, "password">;

//For quizzes that allow multiple attempts
export const scoreToKeepMapCanvas = new Map<string, string>([
	["1", "highest"],
	["2", "average"],
	["3", "first"],
	["4", "last"],
]);
export const scoreToKeepMapMoodle = new Map<string, string>([
	["keep_highest", "highest"],
	["keep_average", "average"],
	["keep_latest", "last"],
]);

//gradebook.ts section
export type gradebookQuizInfo = {
	quiz_name: string;
	grade: {
		fraction?: string;
		percentage?: number;
	};
	attendance: boolean;
	flag_level?: number;
	anomalies_count?: number;
};

export type studentInfoArray = {
	student_name: string;
	lms_user_id?: string;
	status: string;
	flag_level: number;
	anomalies_count: number;
	quizzesInfo: (gradebookQuizInfo & { realQuizId: string })[];
};

export type studentInfoMap = {
	student_name: string;
	lms_user_id?: string;
	status: string;
	overall_grade?: number;
	temp_grade_sum?: number;
	graded_quizzes_count: number;
	flag_level: number;
	anomalies_count: number;
	quizzesInfo: Map<string, gradebookQuizInfo>;
};

export type ApiType<T> = Omit<T, "createdAt" | "updatedAt">;

export type Student = {
	name: string;
	id: number;
	accommodationNotes?: string;
};

export type ExemptedStudent = {
	type?: string;
	name: string;
	userId: number;
	accommodationNotes?: string;
	proctoringOptionProfileId?: number;
};

export type VerityInstituteSettings = {
	allowLiveProctoring: boolean;
	liveProctoringResetableCredits?: number | null;
	liveProctoringCreditsResetDate?: string | null;
	liveProctoringOneTimeCredits: number;
	allowLivePopIn: boolean;
	livePopInResetableCredits?: number | null;
	livePopInCreditsResetDate?: string | null;
	livePopInOneTimeCredits: number;
	allowLivePopInPostReview: boolean;
	allowStandaloneMode: boolean;
	allowAiStrictMode: boolean;
	allowExtensionPlatform: boolean;
	allowLockdownPlatform: boolean;
	allowMobilePlatform: boolean;
	allowDemoMode: boolean;
	showAllAssessments: boolean;
	liteMode: boolean;
	liteModeViewReports: boolean;
	salesforceId?: string | null;
	cleanupEnabled: boolean;
	cutoffDate?: string | null;
	cleanupFrequency?: string | null;
	lastCleanupAt?: string | null;
	allowVerityAssessment: boolean;
};

export const DEFAULT_VERITY_INSTITUTE_SETTINGS: VerityInstituteSettings = {
	liteMode: true,
	liteModeViewReports: false,
	allowExtensionPlatform: false,
	allowLockdownPlatform: false,
	allowMobilePlatform: false,
	allowLiveProctoring: false,
	liveProctoringOneTimeCredits: 0,
	allowLivePopIn: false,
	allowLivePopInPostReview: false,
	livePopInOneTimeCredits: 0,
	allowDemoMode: false,
	allowStandaloneMode: false,
	allowAiStrictMode: false,
	showAllAssessments: true,
	cleanupEnabled: false,
	allowVerityAssessment: true,
};

export type ThirdPartyPlatform = {
	platformName: string;
	platformId: number;
};

export type ThirdPartyPlatformRosters = {
	unselectedPlatformRoster: Record<string, ThirdPartyPlatform>;
	selectedPlatformRoster: Record<string, ThirdPartyPlatform>;
};

export type EditQuizType = "lms" | "verityAssignment" | "verityQuiz" | "standalone";
export type EditQuizEntryPoint = "lms-modal" | "lti-modal" | "lti-page";
